/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocio } from '../../conexiones';
import IItemUnidadAccion from './entidades/itemUnidadAccion';
export default class ModeloItemUnidad {
    public consultarItemsUnidadesPorUnidad(ItemId: number) {
        return manejadorRest<IRespuesta<IItemUnidadAccion>>(
            () => negocio.post('ItemsUnidades/ConsultarItemsUnidadesUnidadCompuesta', { ItemId }),
            true
        );
    }
}
